import API_SPEC_FIELD_TYPES from '@/components/query/helpers/api-spec-field-types';

/**
 * Defines predicates that must not pass in order to allow the custom field
 * to be used in the condition builder.
 */
export default [
    // disallow monetary type handling in UI
    field => field.type === API_SPEC_FIELD_TYPES.monetary,
];
